// newportal/index.js
export default {
	components: {},
	routes: [
		{
			path: '/newportal',
			component: () => import('./dash-layout'), // New layout component
			children: [
				{
					path: '/',
					name: 'NewPortalDashboard',
					component: () => import('./main/dashboard'),
				},
				{
					path: 'invoice',
					name: 'NewPortalInvoice',
					component: () => import('./main/accounting-invoices.vue'),
				},
				{
					path: 'claims',
					name: 'NewPortalClaims',
					component: () => import('./main/claims'),
				},
				{
					path: 'complete-claim',
					name: 'NewPortalCompleteClaim',
					component: () => import('./main/complete-claim'),
				},
				{
					path: 'view-claim/:id',
					name: 'ViewClaim',
					component: () => import('./main/view-claim'),
				},
				{
					path: 'accounts',
					name: 'NewPortalAccounts',
					component: () => import('./main/accounts'),
				},
				{
					path: 'accounts/invoices',
					name: 'NewPortalAccountingInvoices',
					component: () => import('./main/accounting-invoices.vue'),
				},
				{
					path: 'intermediaries',
					name: 'NewPortalIntermediaries',
					component: () => import('./main/intermediaries.vue'),
				},
				{
					path: 'cart',
					name: 'NewPortalCart',
					component: () => import('./main/cart'),
				},
				{
					path: 'top-up-options',
					name: 'NewPortalTopUpOptions',
					component: () => import('./main/top-up-options'),
				},
				{
					path: 'chats',
					name: 'NewPortalChats',
					component: () => import('./main/chats'),
				},
				{
					path: 'products',
					name: 'NewPortalUserProducts',
					component: () => import('./main/products'),
				},
				{
					path: 'products/:id?',
					name: 'ViewPolicy',
					component: () =>
						import('../newportal/main/view-policy.vue'),
				},
				{
					path: 'ipf-requests',
					name: 'NewPortalMy_Loans',
					component: () => import('./main/ipfs'),
				},
				{
					path: 'notifications',
					name: 'NewPortalNotification',
					component: () => import('./main/notifications'),
				},
				{
					path: 'appointments',
					name: 'NewPortalAppointments',
					component: () => import('../newportal/main/appointments'),
				},
				{
					path: 'my-claims',
					name: 'NewPortalClaims',
					component: () => import('../newportal/main/claims'),
				},
				{
					path: 'profile',
					name: 'NewPortalUserProfile',
					component: () => import('./main/profile'),
				},
				{
					path: 'kyc',
					name: 'NewPortalUserKYC',
					component: () => import('./main/kyc'),
				},
				{
					path: 'assessment',
					name: 'NewPortalUserAssessment',
					component: () => import('./main/user-assessment'),
				},
				{
					path: 'quotations',
					name: 'NewPortalQuotations',
					component: () => import('./main/quotations'),
				},
				{
					path: 'valuation',
					name: 'NewPortalValuation',
					component: () => import('./main/valuation'),
				},
				{
					path: 'school/schools',
					name: 'NewPortalSchool_My_Schools',
					component: () => import('./school/my-schools'),
				},
				{
					path: 'school/invoice',
					name: 'NewPortalSchool_Fees_Invoice',
					component: () => import('./school/fee-invoice'),
				},
				{
					path: 'school/loans',
					name: 'NewPortalSchool_Loans',
					component: () => import('./school/school-loans'),
				},
				{
					path: 'my-loans',
					name: 'NewPortalMy_Loans_Alt', // Alternative route for my-loans
					component: () => import('./school/my-loans'),
				},
				{
					path: 'client-quotation-review/:id',
					name: 'NewPortalClientQuotationReview',
					component: () =>
						import('./quotation/client-quotation-preview'),
				},
				{
					path: 'client-quotation-details/:id',
					name: 'NewPortalClientQuotationDetails',
					component: () =>
						import('./quotation/client-quotation-details'),
				},
				{
					path: 'client-quotation-kyc/:id',
					name: 'NewPortalClientQuotationKyc',
					component: () => import('./quotation/kyc-details'),
				},
				{
					path: 'client-quotation-summary/:id',
					name: 'NewPortalClientQuotationSummary',
					component: () => import('./quotation/quotation-summary'),
				},
			],
		},
	],
};
